// Components
import { Card, CardContent, Box, Typography, Skeleton } from "@mui/material";
import { TagName } from "components/TagName";

// Hooks
import useAuth from "utils/hooks/useAuth";
import useChooseYourHub from "./useChooseYourHub";

// Styles
import useStyles from "./ChooseYourHub.styles";
import NavButton from "../../components/HeaderNavigation/NavButton";

const ChooseYourHub = () => {
    const classes = useStyles();
    const { sessionData } = useAuth();

    const { hubs, updateSelectedOrg } = useChooseYourHub();

    return (
        <Box className={classes.mainWrapper}>
            <Card className={classes.cardContainer}>
                <CardContent>
                    <Typography className={classes.title}>Welcome, {sessionData?.authn.user.name}</Typography>
                    <Box mb={3}>
                        <Typography className={classes.subtitle}>Choose your Hub</Typography>
                        <Typography className={classes.intro} paragraph>
                            A hub is a dedicated workspace for an organisation. Here all users part of the hub can
                            collaborate on PACE or Leadership Dynamics Insights, according to the organisation&apos;s
                            products permissions. Please note that your work may be visible to all users in the hub,
                            depending on their permission level.
                        </Typography>
                    </Box>
                    {hubs.data.map((hub) => (
                        <Box key={hub.id} className={classes.hub}>
                            <Box>
                                <TagName>{hub.name}</TagName>
                                <Box sx={{ mt: 1 }}>
                                    <span>LD Permission:</span> {hub.roles_ld.map((role) => role.name)} |
                                    <span>PACE Permission:</span> {hub.roles_pace.map((role) => role.name)}
                                </Box>
                            </Box>
                            <NavButton
                                icon={null}
                                showBackArrow={false}
                                onClick={() => updateSelectedOrg(hub.id)}
                                translationId="chooseYourHub.enter"
                            />
                        </Box>
                    ))}
                    {hubs.status === "fetching" &&
                        Array.from(Array(3)).map((_, i) => <Skeleton animation="wave" height={47} key={i} />)}
                </CardContent>
            </Card>
        </Box>
    );
};

export default ChooseYourHub;
